import { getStrapiURL } from "./api";
import { DataWrapper } from "@/types/types";

function getStrapiMedia(obj: {
  data: DataWrapper<"plugin::upload.file">;
}): string {
  const url = obj.data.attributes.url;
  const imageUrl = url.startsWith("/") ? getStrapiURL(url) : url;
  return imageUrl;
}

export function getStrapiMediaSafe(
  obj:
    | {
        data: DataWrapper<"plugin::upload.file"> | null;
      }
    | null
    | undefined,
): string {
  if (!obj) {
    return "";
  }
  if (obj.data == null) {
    return "";
  }

  return getStrapiMedia({ data: obj.data });
}
